/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum OutBoxStatus {
  Stored = 1,
  WatingForSend = 2,
  IsBeingSent = 3,
  Sent = 4,
  SentAndGiveBackCredit = 5,
  Archived = 6,
  ErrorInSending = 7,
  ErrorInGetItc = 8,
  BlackList = 9,
  WatingForConfirm = 10,
  Archiving = 11,
  SentAndSavedIds = 12,
  CalculationError = 13,
  StoppedByUser = 14
}
